import React from 'react';
import './Notification.css';

const ICONS = {
  error: '✕',
  success: '✓',
  warning: '⚠',
  info: 'ℹ',
};

/**
 * Inline notification — единый компонент для отображения
 * сообщений об ошибках, успехе, предупреждениях и информации.
 *
 * @param {'error'|'success'|'warning'|'info'} variant
 * @param {React.ReactNode} children — текст/содержимое уведомления
 * @param {boolean} [closable] — показать кнопку закрытия
 * @param {function} [onClose] — callback при закрытии
 * @param {object} [style] — дополнительные inline-стили
 * @param {string} [className] — дополнительные CSS-классы
 */
const Notification = ({
  variant = 'error',
  children,
  closable = false,
  onClose,
  style,
  className = '',
}) => {
  if (!children) return null;

  return (
    <div
      className={`notification notification--${variant} ${className}`}
      style={style}
      role="alert"
    >
      <span className="notification__icon">{ICONS[variant]}</span>
      <span className="notification__content">{children}</span>
      {closable && onClose && (
        <button
          className="notification__close"
          onClick={onClose}
          aria-label="Закрыть"
        >
          ×
        </button>
      )}
    </div>
  );
};

export default Notification;
